/**
 * The Lightspeed tag the Vaperite sync reads to set Sell in app: tagged = sold in the app.
 * Mirrors VAPERITE_SELL_IN_APP_TAG in the backend (vend-sync/vaperite-tag-builder.js); the two
 * must match. Was `woocommerce` until 4 Nov 2026. The API field names (noWoocommerce,
 * allowNoWoocommerce, onlyNoWoocommerce) keep the old word; only what people read changed.
 */
export const VAPERITE_SELL_IN_APP_TAG = 'deeliver';
